import FundSummaryComponent from './FundSummaryContainer';

export default FundSummaryComponent;
